import { render, staticRenderFns } from "./PhoneDeliveryItems.vue?vue&type=template&id=d991c44e"
import script from "./PhoneDeliveryItems.vue?vue&type=script&lang=js"
export * from "./PhoneDeliveryItems.vue?vue&type=script&lang=js"
import style0 from "./PhoneDeliveryItems.vue?vue&type=style&index=0&id=d991c44e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports